import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { EprBom } from "@/app/services/generated/eprbomService";
import { eprBomService } from "@/app/services/generated/eprbomService";

export interface IHasEprBomsCache {
  eprBoms: EprBomsCache;
}

// Singleton cache store
const eprBomsCacheStore = new EntityCacheStore<EprBom>(
  EnumCacheEntityType.eprBom,
  async () => eprBomService.getAllEprBoms()
);

// Ephemeral reader
export default class EprBomsCache extends EntityWithGuidKeyCache<EprBom> {
  constructor() {
    super(eprBomsCacheStore, (x) => x.header.id);
  }
}
